import { useState } from "react";
import { Accordion } from "components/molecules/Accordion";
import { AccordionItem } from "components/molecules/Accordion/AccordionItem";
import { useViewPrepInfoQuery } from "services/homeApi";
import { PDFVIewer } from "./PDFViewer";
import { Spinner } from "components/atoms/Icon";
import { FetchError } from "components/molecules";
import { HtmlRenderer } from "./HtmlRenderer";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const ViewPrep = ({ theme }: IProps) => {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const { isLoading, isError, data } = useViewPrepInfoQuery();

  const handleAccordionToggle = (key: string) => {
    setOpenAccordion(openAccordion === key ? null : key);
  };

  const extractHrefs = (inputString: string, fromEmbed?: boolean) => {
    const hrefRegex = fromEmbed
      ? /<embed[^>]*src="([^"]*\.pdf(?:[^"]*)?)"/g
      : /href="([^"]*\.pdf(?:[^"]*)?)"/g;
    const hrefs = [];
    let match;
    while ((match = hrefRegex.exec(inputString)) !== null) {
      hrefs.push(match[1]);
    }
    return hrefs;
  };

  const extractTitle = (input: string): string => {
    const regex = /<sub-panel-header>([\s\S]*?)<\/sub-panel-header>/;
    const title = input.match(regex);
    return title ? title[1].replace(/&amp;/g, "&") : "";
  };

  return isLoading ? (
    <Spinner theme={theme} />
  ) : isError ? (
    <FetchError content="Oops! failed to load resources." />
  ) : (
    <Accordion>
      {data.map((value: any, index: number) => (
        <AccordionItem
          key={index + 1}
          title={extractTitle(value.TextData)}
          isOpen={openAccordion === `${index + 1}`}
          styles="view-prep-accordion-item"
          onToggle={() => handleAccordionToggle(`${index + 1}`)}
          theme={theme}
        >
          {
            <>
              <HtmlRenderer htmlContent={value.TextData} />

              {extractHrefs(value.TextData, true).length > 0
                ? extractHrefs(value.TextData, true).map(
                    (val: any, key: number) => <PDFVIewer url={val} key={key} />
                  )
                : null}
            </>
          }
        </AccordionItem>
      ))}
    </Accordion>
  );
};
